<template>
  <div>
    <a-tooltip>
      <template slot="title">
        <!-- 个人贷款：审批通过未签约 (04) -->
        <template v-if="status?.value=='04' && !isEnterprise">
          <div style="margin-bottom: 8px; color: #fff;">需签署以下2份文件：</div>
          <a-button type="primary" size="small" @click="toSign('A')" style="margin-bottom: 4px;">
            签署贷款合同
          </a-button><br/>
          <a-button type="primary" size="small" @click="toSign('B')">
            签署融资成本明示
          </a-button>
        </template>
        <!-- 个人贷款：已签约 (06) -->
        <template v-else-if="status?.value=='06' && !isEnterprise">
          <a-button type="primary" size="small" @click="toSign('A')" style="margin-bottom: 4px;">
            查看贷款合同
          </a-button><br/>
          <a-button type="primary" size="small" @click="toSign('B')">
            查看融资成本明示
          </a-button>
        </template>
        <!-- 企业贷款：保持原样 -->
        <a-button v-else-if="status?.value=='04'" type="primary" size="small" @click="toSign('A')">
          去签约<a-icon type="right" />
        </a-button>
        <a-button v-else-if="status?.value=='06'" type="primary" size="small" @click="toSign('A')">
          查看合同<a-icon type="right" />
        </a-button>
        <template v-else>{{selectData.statusDesc}}</template>
      </template>
      <a-tag :color="status?.color">{{status?.label}}</a-tag>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    selectData: {
      required: true,
      type: Object
    },
    status: {
      required: true,
      type: Object
    }
  },
  computed: {
    isEnterprise() {
      // 企业贷款 custtypecd = 2，个人贷款 custtypecd = 1
      return String(this.selectData.custtypecd) === '2'
    }
  },
  mounted() {
    console.info(this.status, this.selectData)
  },
  methods: {
    async toSign(type) {
      let data = {
        channel_no: this.selectData.channelNo,
        app_no: this.selectData.appNo,
        product_id: this.selectData.productId,
        online_serial_no: this.selectData.onlineSerialNo,
        sign_info_type: type || 'A',
      }
      const res = await this.api.creditSignFlowsUrlsApi(data)
      if (res.code !== 200) {
        this.$message.warning(res.info)
        return
      }
      window.open(res.data.recode_list[0].sign_url)
    }
  }
}
</script>

<style></style>
